<ng-container *ngIf="item && item.id">
        <div style="position:absolute;width:auto;height:20px;font-size:12px;text-align:center;padding:3px;background-color:#555;color:#fff;">
            <span style="color:yellow;font-size:9px;">{{ label }}</span> {{ item.id }}
        </div>
    </ng-container>